import { render } from "./PayMotion.vue?vue&type=template&id=20126f9b&scoped=true"
import script from "./PayMotion.vue?vue&type=script&lang=js"
export * from "./PayMotion.vue?vue&type=script&lang=js"

import "./PayMotion.vue?vue&type=style&index=0&id=20126f9b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20126f9b"]])

export default __exports__